import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getSelectedFacetNameFirstAttribute } from 'selectors/algolia2/facets'
import { hasPrintsSelected } from '../selectors/facets'

const mapStateToProps = createStructuredSelector({
  category: (state, ownProps) => getSelectedFacetNameFirstAttribute('category')(state),
  hasPrints: hasPrintsSelected,
})

export type ConnectorProps = {
  category: string
  hasPrints: boolean
}
export default connect(mapStateToProps)
